import '../../modules/mode-components';

import { getCurrentUsername, getOwnerUsername } from '@mode/shared/util-js';
import * as angular from 'angular';
import { Observable } from 'rxjs';

import { FeatureFlagHelpers } from '../../common/feature-flag-helpers';
import { FeatureToggleService } from '../../services/feature-toggle-service';

class SimpleHeaderController {
  static $inject = [
    '$scope',
    '$window',
    '$timeout',
    'AccountModel',
    'SpaceModel',
    'ModeCollection',
    'ApiModel',
    '$q',
    'FeatureToggleService',
  ];

  public account: any;
  public organizations: any[];
  public spaces: any[];
  public owner: any;
  public datasources: any[];
  private isCommunityContext: boolean;
  private showModeStudio$: Observable<boolean>;
  private intercomChatEnabled$: Observable<boolean>;

  constructor(
    public $scope,
    public $window,
    public $timeout,
    public AccountModel,
    public SpaceModel,
    public ModeCollection,
    public ApiModel,
    public $q,
    public featureToggleService: FeatureToggleService
  ) {}

  $onInit() {
    this.$q.all([this.getAccount(), this.getOwner()]).then(this.$q.spread(this.getAccountAndOwnerResources.bind(this)));
    this.showModeStudio$ = this.featureToggleService.featureModeStudioEnabled$;
    this.intercomChatEnabled$ = this.featureToggleService.featureIntercomChatEnabled$;
  }

  getAccount() {
    const accountId = getCurrentUsername(this.$window.document);
    return this.AccountModel.find({
      username: accountId,
      useEntryPath: true,
      refresh: true,
    });
  }

  getOwner() {
    const ownerId = getOwnerUsername(this.$window.document);
    return this.AccountModel.find({
      username: ownerId,
      useEntryPath: true,
      includes: ['organization_features'],
    });
  }

  getAccountAndOwnerResources(account, owner) {
    this.account = account;
    this.owner = owner;

    owner
      .spaces()
      .then(this.ModeCollection.elements)
      .then((spaces) => {
        this.spaces = spaces.sort(this.SpaceModel.navbarSort);
      });

    this.isCommunityContext = this.owner.user;

    // load feature state
    this.featureToggleService.updateLocalState(
      FeatureFlagHelpers.orgToFeatureFlags(account._resource, owner._resource)
    );
  }
}

const SimpleHeaderComponent: angular.IComponentOptions = {
  bindings: {
    title: '@?',
    headerStyle: '@',
  },
  controller: SimpleHeaderController,
  controllerAs: 'ctrl',
  template: `
<div class="top-level-header dark-sidebar">
  <nav-flyout theme="'dark'"></nav-flyout>
  <a ng-href="{{ ctrl.owner.homeLink }}" class="mode-header-avatar" ng-if="ctrl.owner">
    <mode-avatar
      options="ctrl.owner.avatar"
      size="25"
      community="{{ ctrl.owner.user }}">
    </mode-avatar>
  </a>
</div>
<div class="header-title">{{ ctrl.title }}</div>
<div class="header-tools">
  <mode-help-menu
    class="help-menu-component"
    [is-community]="ctrl.isCommunityContext"
    [intercom-chat-enabled]="ctrl.intercomChatEnabled$ | async:this"
    theme="dark"
  ></mode-help-menu>
  <mode-trial-banner
    [billing-link]="ctrl.account.billingLink"
    [user-email]="ctrl.owner.userEmail"
    [user-display-name]="ctrl.owner.userDisplayName"
  ></mode-trial-banner>
  <mode-studio
    ng-if="ctrl.showModeStudio$ | async:this"
    [org-username]="ctrl.owner.username"
    theme="dark"
  ></mode-studio>
</div>
  `,
};

angular.module('mode.components').component('simpleHeader', SimpleHeaderComponent);
